import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  notificationsPermissionStatus?:  { status: 'granted' | 'undetermined' | 'denied'; granted: boolean; canAskAgain: boolean };
  cameraPermissionStatus?: { status: 'granted' | 'undetermined' | 'denied'; granted: boolean; canAskAgain: boolean };
  deviceInfo?: {deviceOS : "ios" | "android" | "windows" | "macos" | "web", deviceVersion: string | number };
  locationPermissionStatus?: { status: 'granted' | 'undetermined' | 'denied'; granted: boolean; canAskAgain: boolean } & {
    ios?: {scope: 'whenInUse' | 'always' | 'none'};
    android?: {accuracy: 'fine' | 'coarse' | 'none'};
  };
  location?: {latitude: number; longitude: number, timestamp: number};
  isUserInOperatingArea?: boolean;


  requestCameraPermission() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "request-camera-permissions", data: null}));
  }
}